/** fenxi 设计 token — 微信公众号后台「数据分析」风格
 *
 * 单一真相源:tailwind.config.js / main.tsx(antd)/ globals.css / 各组件 都从这里读
 * 改色只改这一处,不要在组件里硬编码
 */
export const wechatTheme = {
  brand: {
    DEFAULT: '#07C160', // 微信绿
    hover:    '#06AD56',
    active:   '#059048',
    tint:     '#E7F8EE', // 选中底/卡片浅底
    tintAlt:  '#F0FAF4',
    gradient: 'linear-gradient(135deg, #07C160 0%, #059048 100%)',
  },
  link: {
    DEFAULT: '#576B95', // 微信蓝
    hover:   '#44558B',
  },
  status: {
    success:    '#07C160',
    processing: '#10AEFF',
    warning:    '#FA9D3B',
    error:      '#FA5151',
    neutral:    '#888888',
  },
  text: {
    primary:   '#1A1A1A',   // mp 实际 #1A1B1C,差 1,可忽略
    secondary: '#353535',   // mp 实际完全一致
    tertiary:  '#4C4D4E',   // 2026-06-04 采样 mp 三文色,旧估 #888888 太浅
    disabled:  '#BBBBBB',
    inverse:   '#FFFFFF',
  },
  bg: {
    body:    '#F6F7F8',   // 2026-06-04 采样 mp 页面底,旧估 #F7F7F7 偏黄
    card:    '#FFFFFF',
    section: '#FAFAFA',
    hover:   '#F2F2F2',
  },
  border: {
    DEFAULT: '#E5E5E5',
    light:   '#F0F0F0',
    strong:  '#D9D9D9',
  },
  radius: {
    sm: 2,
    md: 4,
    lg: 6,
  },
  // 2026-06-04 mp 字体栈:mp-quote + system-ui + -apple-system 前缀(精准对齐)
  fontFamily:
    'mp-quote, -apple-system-font, system-ui, "PingFang SC", "Helvetica Neue", ' +
    '"Hiragino Sans GB", "Microsoft YaHei", -apple-system, BlinkMacSystemFont, ' +
    '"Segoe UI", sans-serif',
  // 动画时长
  transition: {
    fast: '0.15s ease',
    normal: '0.2s ease',
    slow: '0.3s ease',
  },
  shadow: {
    sm: '0 1px 2px rgba(0,0,0,0.04)',
    DEFAULT: '0 1px 3px rgba(0,0,0,0.08)',
    md: '0 2px 8px rgba(0,0,0,0.12)',
    lg: '0 4px 16px rgba(0,0,0,0.16)',
    xl: '0 8px 24px rgba(0,0,0,0.2)',
  },
} as const;

export type WechatTheme = typeof wechatTheme;
